"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _Tracking = require("@jobmatchme/tracking/es/provider/Tracking");

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ArrowGreen = _interopRequireDefault(require("./images/ArrowGreen.svg"));

var _FadeIn = require("@jobmatchme/ui/es/components/FadeIn");

var _Authentication = require("../../provider/Authentication");

var _Matches = require("../../provider/Matches");

var _Profile = require("../../provider/Profile");

var _Route = require("../../provider/Route");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _JmmLoader = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/JmmLoader"));

var _LanguageSkillsModal = require("../LanguageSkillsModal");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Welcome = function Welcome() {
  var translateNs = 'pc-matching:WelcomeBack';

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useContext = (0, _react.useContext)(_Matches.MatchesContext),
      list = _useContext.list,
      status = _useContext.status;

  var _useContext2 = (0, _react.useContext)(_Authentication.AuthenticationContext),
      user = _useContext2.user,
      isLoading = _useContext2.isLoading;

  var _useContext3 = (0, _react.useContext)(_Profile.ProfileContext),
      discriminator = _useContext3.discriminator;

  var matchesNumber = (list || []).length;
  var matchesLoading = status !== 'done';
  var timeoutRef = (0, _react.useRef)(null);

  var _useContext4 = (0, _react.useContext)(_Route.RouteActionsContext),
      routeInternal = _useContext4.routeInternal;

  var showMatches = function showMatches() {
    return routeInternal('appHome');
  };

  (0, _react.useEffect)(function () {
    if (isLoading === false && user && user.username) {
      // save returned user to our trackingService
      var userComeBack = sessionStorage.getItem('userComeBack');

      if (!userComeBack) {
        (0, _Tracking.trackEvent)({
          eventName: 'jmmPcWelcomeBack',
          pcUuid: user.username,
          payload: {}
        });
        sessionStorage.setItem('userComeBack', 'true');
      }
    }
  }, [isLoading, user]); // If no matches have been found, navigate to matches / checkout page

  (0, _react.useEffect)(function () {
    if (!isLoading && !matchesLoading && matchesNumber === 0) {
      timeoutRef.current = setTimeout(function () {
        showMatches();
      }, 100);
    }

    return function () {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LanguageSkillsModal.DisplayModalIfEmptyLanguages, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      className: _styleModule.default.content,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
        className: _styleModule.default.welcome,
        children: [t("".concat(translateNs, ".greet")), "\xA0", user ? user.attributes.name : '']
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        component: "h1",
        className: _styleModule.default.headline,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          children: t("".concat(translateNs, ".description"))
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      className: _styleModule.default.buttonWrapper,
      children: matchesLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FadeIn.SimpleFadeIn, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_JmmLoader.default, {
          fullPage: true
        })
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FadeIn.SimpleFadeIn, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          color: "primary",
          variant: "contained",
          round: true,
          flat: true,
          bold: true,
          texttransform: "none",
          onClick: showMatches,
          className: _styleModule.default.button,
          children: t("".concat(translateNs, ".showMatches"), {
            count: matchesNumber
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          className: _styleModule.default.arrow,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: _ArrowGreen.default,
            className: "".concat(discriminator === 'truck' ? _styleModule.default.colorRevert : ''),
            alt: ""
          })
        })]
      })
    })]
  });
};

var _default = Welcome;
exports.default = _default;